import { render, staticRenderFns } from "./Newbanner.vue?vue&type=template&id=b9e5777e&"
import script from "./Newbanner.vue?vue&type=script&lang=js&"
export * from "./Newbanner.vue?vue&type=script&lang=js&"
import style0 from "./Newbanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports